(() => {
  const MOBILE_BREAKPOINT = 750;
  const ASSET_BASE = new URL('.', document.currentScript.src).href;
  const ICON_ASSET_VERSION = '20260629-1045';
  const COMPOSER_LINE_HEIGHT = 22;
  const COMPOSER_MAX_LINES = 3;
  const MAX_IMAGE_ATTACHMENTS = 1;
  const MAX_IMAGE_DIMENSION = 1024;
  const IMAGE_QUALITY = 0.82;
  const DICTATION_TRANSCRIBING_MS = 650;
  const ALLOWED_BUTTON_LINK_HOSTS = new Set([
    'cdn.shopify.com',
    'jsdspace.com',
    'www.jsdspace.com',
    'jsd-space.myshopify.com',
  ]);

  const vehicleYears = {
    'Ford Mustang': ['2005-2009', '2010-2014', '2015-2017', '2018-2023', '2024+'],
    'Ford Bronco': ['2021+'],
    'Jeep Wrangler': [],
    'Subaru WRX': ['2015-2021', '2022+'],
    'Dodge Charger': [],
    'Dodge Challenger': ['2008-2014', '2015-2023'],
    'Tesla Model Y': [],
    'Tesla Model 3': [],
  };

  const products = [
    {
      id: 'tml-headlight-covers',
      handle: 'tml-smoked-acrylic-headlight-covers-for-2024-ford-mustang',
      title: 'TML Smoked Acrylic Headlight Covers for 2024+ Ford Mustang',
      image: 'jsd-chatbot-product.png',
      comparePrice: '$89.00 USD',
      price: '$69.00 USD',
      compatibility: 'Mustang 2024+',
      material: 'Smoked Acrylic',
      color: 'Smoked Black',
    },
    {
      id: 'jsd-tail-light-covers',
      handle: 'jsd-tail-light-covers',
      title: 'JSD Smoke Series Tail Light Covers for 2024+ Ford Mustang',
      image: 'jsd-chatbot-product.png',
      comparePrice: '$79.00 USD',
      price: '$59.00 USD',
      compatibility: 'Mustang 2024+',
      material: 'Impact Acrylic',
      color: 'Dark Smoke',
    },
    {
      id: 'orbit-front-splitter',
      handle: 'orbit-front-splitter',
      title: 'Orbit Street Front Splitter for 2024+ Ford Mustang',
      image: 'jsd-chatbot-product.png',
      comparePrice: '$249.00 USD',
      price: '$219.00 USD',
      compatibility: 'Mustang 2024+',
      material: 'ABS Composite',
      color: 'Gloss Black',
    },
  ];

  const icons = {
    vehicle: 'jsd-chatbot-vehicle.svg',
    compare: 'jsd-chatbot-compare.svg',
    install: 'jsd-chatbot-installation.svg',
  };

  const afterPaint = (callback) => {
    const scheduler = typeof requestAnimationFrame === 'function'
      ? requestAnimationFrame
      : window.requestAnimationFrame;
    return scheduler ? scheduler(callback) : window.setTimeout(callback, 0);
  };

  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character]);

  const safeLink = (value) => {
    try {
      if (typeof value !== 'string' || !value.trim()) return '';
      const base = window?.location?.href || document.currentScript?.src || 'https://jsdspace.com/';
      const url = new URL(value.trim(), base);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (_error) {
      return '';
    }
  };

  const safeButtonLink = (value) => {
    const href = safeLink(value);
    if (!href) return '';
    const url = new URL(href);
    return ALLOWED_BUTTON_LINK_HOSTS.has(url.hostname.toLowerCase()) ? href : '';
  };

  const preservePreviewTheme = (href) => {
    if (!href) return '';
    try {
      const current = new URL(window.location.href);
      const previewThemeId = current.searchParams.get('preview_theme_id');
      if (!previewThemeId) return href;
      const url = new URL(href);
      if (!ALLOWED_BUTTON_LINK_HOSTS.has(url.hostname.toLowerCase())) return href;
      if (!url.searchParams.has('preview_theme_id')) {
        url.searchParams.set('preview_theme_id', previewThemeId);
      }
      return url.href;
    } catch (_error) {
      return href;
    }
  };

  const productUrl = (product = {}) => (
    preservePreviewTheme(safeButtonLink(product.url)
    || (product.handle ? safeButtonLink(`/products/${product.handle}`) : ''))
  );

  const renderInlineMarkdown = (value) => escapeHtml(value)
    .replace(/\*\*([^*\n]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[\s(])\*([^*\n]+)\*(?=$|[\s).,!?:;])/g, '$1<em>$2</em>');

  const renderLimitedMarkdown = (value) => {
    let link = null;
    const text = String(value).replace(/\[([^\]]+)]\(([^)\s]+)\)/g, (_match, label, href) => {
      const url = safeButtonLink(href);
      if (!url) return label;
      const displayLabel = new URL(url).pathname.replace(/\/$/, '') === '/pages/contact' ? 'Contact Us' : label;
      if (!link) {
        link = { label: displayLabel.trim().slice(0, 80) || 'Learn More', url };
      }
      return displayLabel;
    }).replace(/https?:\/\/[^\s)]+/g, (urlText) => {
      const url = safeButtonLink(urlText);
      if (!url) return urlText;
      if (!link) {
        link = {
          label: /manual|\.pdf(?:[?#]|$)/i.test(urlText) ? 'Installation Manual' : 'Open link',
          url,
        };
        return '';
      }
      return urlText;
    });
    const blocks = [];
    let listType = '';
    let listItems = [];
    const flushList = () => {
      if (!listItems.length) return;
      blocks.push(`<${listType}>${listItems.map((item) => `<li>${renderInlineMarkdown(item)}</li>`).join('')}</${listType}>`);
      listType = '';
      listItems = [];
    };

    text.split(/\r?\n/).forEach((line) => {
      const heading = line.match(/^\s{0,3}#{1,6}\s+(.+)/);
      if (heading) {
        flushList();
        blocks.push(`<p><strong>${renderInlineMarkdown(heading[1].trim())}</strong></p>`);
        return;
      }
      const unordered = line.match(/^\s*[-*]\s+(.+)/);
      const ordered = line.match(/^\s*\d+\.\s+(.+)/);
      const nextListType = unordered ? 'ul' : ordered ? 'ol' : '';
      if (nextListType) {
        if (listType && listType !== nextListType) flushList();
        listType = nextListType;
        listItems.push((unordered || ordered)[1]);
        return;
      }
      flushList();
      if (line.trim()) blocks.push(`<p>${renderInlineMarkdown(line.trim())}</p>`);
    });
    flushList();
    return { html: blocks.join(''), link };
  };

  const plainMessageText = (value) => String(value)
    .replace(/\[([^\]]+)]\([^)]+\)/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/^\s*(?:[-*]|\d+\.)\s+/gm, '')
    .trim();

  const sanitizeHandle = (value) => {
    const handle = String(value || '').trim().toLowerCase();
    return /^[a-z0-9][a-z0-9-]*$/.test(handle) ? handle : '';
  };

  const hasNewProductSearchIntent = (message) => (
    /\b(antennas?|storage|armrest|chin|spoilers?|louvers?|louver|decklid|blackout|panel|headlights?|taillights?|tail|light|covers?|splitters?|scoops?|grille|trim|knob|handle|diffuser|window|quarter|roof|side)\b/i
      .test(String(message || ''))
  );

  const hasContextualProductFollowup = (message) => {
    const text = String(message || '').toLowerCase();
    if (/\b(?:this|that|these|those|them|they|both|it|one|ones|version)\b/.test(text)
      && /\b(?:install|installation|manual|instructions?|compare|comparison|difference|different|more|info|details?|fit|fits|fitment|compatible|compatibility|stock|available|availability|price|cost|color|colour|material|finish|shipping|made|carbon|acrylic|ABS|rubber|work|performance|improve|replacement|replace|overlay)\b/i.test(text)) {
      return true;
    }
    if (/\b(?:better than|better .*than|radio reception|first one called|you(?: are|'re) wrong|already (?:showed|shown|told)|as I (?:have )?shown|there (?:are|were) (?:2|two)|go back|(?:first|second|other|cheaper|expensive) (?:one|product|item|option)|that(?: is|'s|’s) wrong|we (?:chose|decided))\b/i.test(text)) return true;
    if (/^\s*(?:(?:this|that|these|those|it)(?:\s+one)?|the other one|what about this one)\s*\??\s*$/i.test(text)) return true;
    if (/^\s*(?:compare|difference|different|how\s+do\s+i\s+install|install(?:ation)?(?:\s+help)?|manual|instructions?)\s*\??\s*$/i.test(text)) {
      return true;
    }
    // A conversational continuation need not repeat a product noun or a fixed
    // keyword ('What should I clean it with?', 'Can I drive immediately?').
    // Fresh searches, filter changes and account/policy topics remain unscoped.
    return !hasNewProductSearchIntent(message)
      && !/\b(?:show|find|recommend|browse|search|budget|spend|only|exclude|excluding|no|shipping|refund|returns?|orders?|tracking|account|payment|charged|password|email|contact|coupon|damaged|defective|broken|complaint)\b/i.test(text);
  };

  const normalizeReferenceProduct = (product) => {
    const handle = sanitizeHandle(product?.handle);
    if (!handle) return null;
    const title = String(product?.title || 'Selected item').trim().slice(0, 200);
    return {
      handle,
      title,
      image: safeLink(product?.image),
      imageAlt: String(product?.imageAlt || title).trim().slice(0, 200),
    };
  };

  const normalizeImageAttachment = (attachment) => {
    const dataUrl = String(attachment?.dataUrl || '').trim();
    if (!/^data:image\/(?:png|jpe?g|webp|gif);base64,[a-z0-9+/=]+$/i.test(dataUrl)) return null;
    const name = String(attachment?.name || 'Attached photo').trim().slice(0, 120);
    return {
      dataUrl,
      name,
      image: dataUrl,
      imageAlt: name,
    };
  };

  class JsdSpaceChatbot extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.assetBase = ASSET_BASE;
      this.apiUrl = this.dataset.apiUrl?.trim() || '';
      this.currentProductHandle = sanitizeHandle(this.dataset.currentProductHandle);
      this.currentProductTitle = this.dataset.currentProductTitle?.trim() || '';
      this.currentProductImage = safeLink(this.dataset.currentProductImage);
      this.currentProductImageAlt = this.dataset.currentProductImageAlt?.trim() || this.currentProductTitle;
      this.pending = false;
      this.storageKey = this.dataset.storageKey || 'jsd-space-chatbot-v1';
      this.launcher = this.querySelector('.jsd-chatbot__launcher');
      this.panel = this.querySelector('.jsd-chatbot__panel');
      this.backdrop = this.querySelector('.jsd-chatbot__backdrop');
      this.closeButton = this.querySelector('.jsd-chatbot__close');
      this.restartButton = this.querySelector('.jsd-chatbot__restart');
      this.restartDialog = this.querySelector('.jsd-chatbot__restart-dialog');
      this.restartCancel = this.querySelector('.jsd-chatbot__restart-cancel');
      this.restartConfirm = this.querySelector('.jsd-chatbot__restart-confirm');
      this.vehicleBanner = this.querySelector('.jsd-chatbot__vehicle-banner');
      this.vehicleBannerText = this.querySelector('.jsd-chatbot__vehicle-banner-text');
      this.vehicleBannerActionWrap = this.querySelector('.jsd-chatbot__vehicle-banner-action-wrap');
      this.vehicleBannerAction = this.querySelector('.jsd-chatbot__vehicle-banner-action');
      this.messages = this.querySelector('.jsd-chatbot__messages');
      this.form = this.querySelector('.jsd-chatbot__composer');
      this.input = this.querySelector('.jsd-chatbot__input-row textarea, .jsd-chatbot__input-row input');
      this.referenceBox = this.querySelector('.jsd-chatbot__reference-box');
      this.imageInput = this.querySelector('.jsd-chatbot__image-input');
      this.cameraButton = this.querySelector('.jsd-chatbot__camera');
      this.micButton = this.querySelector('.jsd-chatbot__mic');
      this.dictation = this.querySelector('.jsd-chatbot__dictation');
      this.dictationTimer = this.querySelector('.jsd-chatbot__dictation-timer');
      this.dictationMeterBars = [...this.querySelectorAll('.jsd-chatbot__dictation-meter span')];
      this.dictationEndButton = this.querySelector('.jsd-chatbot__dictation-end');
      this.sendButton = this.querySelector('.jsd-chatbot__send');
      this.state = this.restoreState();
      this.state.open = false;
      this.bindEvents();
      this.initializeMediaControls();
      this.render();
    }

    defaultState() {
      return { messages: [], selectedProducts: [], selectedVehicle: null, referenceProducts: [], referenceText: '', imageAttachments: [], openProductLists: [], open: false };
    }

    sharedStorage() {
      return typeof localStorage !== 'undefined' ? localStorage : window.localStorage;
    }

    legacyStorage() {
      return typeof sessionStorage !== 'undefined' ? sessionStorage : window.sessionStorage;
    }

    readStoredState() {
      return this.sharedStorage()?.getItem(this.storageKey) || this.legacyStorage()?.getItem(this.storageKey) || null;
    }

    normalizeStoredState(saved) {
      if (!saved || typeof saved !== 'object') return this.defaultState();
      // Retire saved in-chat pickers. Vehicle selection now belongs to the storefront.
      const messages = Array.isArray(saved.messages)
        ? saved.messages.filter((entry) => entry && !['vehicle-grid', 'vehicle-year-grid', 'fitment-setup'].includes(entry.type))
        : [];
      const savedReferenceProducts = Array.isArray(saved.referenceProducts)
        ? saved.referenceProducts.map(normalizeReferenceProduct).filter(Boolean)
        : [];
      const selectedVehicle = this.sharedSelectedVehicle();
      const legacyReferenceProduct = normalizeReferenceProduct(saved.referenceProduct);
      return {
        messages,
        selectedProducts: Array.isArray(saved.selectedProducts) ? saved.selectedProducts : [],
        selectedVehicle,
        referenceProducts: savedReferenceProducts.length
          ? savedReferenceProducts
          : legacyReferenceProduct ? [legacyReferenceProduct] : [],
        referenceText: typeof saved.referenceText === 'string' ? saved.referenceText : '',
        imageAttachments: [],
        openProductLists: Array.isArray(saved.openProductLists) ? saved.openProductLists.filter((key) => typeof key === 'string') : [],
        open: false,
      };
    }

    restoreState() {
      try {
        const stored = this.readStoredState();
        const saved = stored ? JSON.parse(stored) : null;
        if (saved && typeof saved === 'object') return this.normalizeStoredState(saved);
      } catch (error) {
        console.warn('JSD chatbot state could not be restored.', error);
      }
      return { ...this.defaultState(), selectedVehicle: this.sharedSelectedVehicle() };
    }

    saveState() {
      try {
        this.sharedStorage()?.setItem(this.storageKey, JSON.stringify({
          messages: this.state.messages,
          selectedProducts: this.state.selectedProducts,
          selectedVehicle: this.state.selectedVehicle,
          referenceProducts: this.state.referenceProducts,
          referenceText: this.state.referenceText,
          openProductLists: this.state.openProductLists,
        }));
        this.legacyStorage()?.removeItem(this.storageKey);
      } catch (error) {
        console.warn('JSD chatbot state could not be saved.', error);
      }
    }

    clearStoredState() {
      try {
        this.sharedStorage()?.removeItem(this.storageKey);
        this.legacyStorage()?.removeItem(this.storageKey);
      } catch (error) {
        console.warn('JSD chatbot state could not be cleared.', error);
      }
    }

    handleStorageSync(event) {
      if (event.key !== this.storageKey) return;
      const wasOpen = Boolean(this.state?.open);
      if (!event.newValue) {
        this.fitmentTask = null;
        this.returnFromVehicleSelector = false;
        this.requestController?.abort();
        this.requestController = null;
        this.pending = false;
        this.clearComposerDraft();
        this.state = this.defaultState();
        this.state.selectedVehicle = this.sharedSelectedVehicle();
      } else {
        try {
          const synced = this.normalizeStoredState(JSON.parse(event.newValue));
          // A form belongs to this tab. Storage restoration intentionally strips
          // transient forms, so retain our active task when another tab syncs.
          if (this.fitmentTask) {
            if (JSON.stringify(synced.selectedVehicle) !== JSON.stringify(this.state.selectedVehicle)) {
              this.fitmentTask.year = '';
              this.fitmentTask.trim = '';
            }
            synced.referenceProducts = this.state.referenceProducts;
            synced.messages.push({ type: 'fitment-setup', fitmentId: this.fitmentTask.id });
          }
          this.state = synced;
        } catch (error) {
          console.warn('JSD chatbot state could not be synced.', error);
          return;
        }
      }
      this.state.open = wasOpen;
      this.render();
    }

    bindEvents() {
      this.launcher.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.restartButton.addEventListener('click', () => this.openRestartDialog());
      this.restartCancel.addEventListener('click', () => this.closeRestartDialog());
      this.restartConfirm.addEventListener('click', () => this.startNewChat());
      this.vehicleBanner?.addEventListener('click', () => this.changeView('vehicle'));
      this.backdrop.addEventListener('click', () => this.close());
      this.form.addEventListener('submit', (event) => this.submitMessage(event));
      this.input.addEventListener('input', () => this.updateComposer());
      this.input.addEventListener('keydown', (event) => this.handleComposerKeydown(event));
      this.cameraButton?.addEventListener('click', () => this.handleCameraClick());
      this.imageInput?.addEventListener('change', (event) => this.handleImageSelected(event));
      this.micButton?.addEventListener('click', () => this.handleMicClick());
      this.dictationEndButton?.addEventListener('click', () => this.endDictation());
      this.messages.addEventListener('click', (event) => this.handleAction(event));
      this.messages.addEventListener('input', (event) => {
        const field = event.target.dataset?.fitmentField;
        if (this.fitmentTask && ['query', 'year', 'trim'].includes(field)) {
          this.fitmentTask[field] = event.target.value;
        }
      });
      this.messages.addEventListener('toggle', (event) => this.handleProductListToggle(event), true);
      const preserveReadingPosition = () => {
        if (this.pending) this.userScrolledDuringReply = true;
      };
      this.messages.addEventListener('wheel', preserveReadingPosition, { passive: true });
      this.messages.addEventListener('touchmove', preserveReadingPosition, { passive: true });
      this.messages.addEventListener('pointerdown', (event) => {
        if (event.target === this.messages) preserveReadingPosition();
      });
      this.messages.addEventListener('keydown', (event) => {
        if (['PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown'].includes(event.key)) preserveReadingPosition();
      });
      this.referenceBox.addEventListener('click', (event) => this.handleRemoveSelection(event));
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-jsd-chatbot-product]');
        if (trigger) {
          this.openWithProductReference({
            handle: trigger.dataset.productHandle || this.currentProductHandle,
            title: trigger.dataset.productTitle || this.currentProductTitle || 'this item',
            image: trigger.dataset.productImage || this.currentProductImage,
            imageAlt: trigger.dataset.productImageAlt || this.currentProductImageAlt,
          }, {
            replace: trigger.dataset.jsdReferenceMode === 'replace',
          });
        }
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event));
      window.addEventListener('resize', () => this.syncModalBehavior());
      window.addEventListener?.('storage', (event) => this.handleStorageSync(event));
      document.addEventListener('jsd:vehicle-change', (event) => this.syncSelectedVehicle(event.detail));
      document.addEventListener('jsd:vehicle-selector-open', () => {
        if (this.state.open) this.close();
      });
      document.addEventListener('jsd:vehicle-selector-close', (event) => this.handleVehicleSelectorClose(event));
      document.addEventListener('jsd-chatbot:open-product', (event) => {
        this.openWithProductReference({
          handle: event.detail?.handle || this.currentProductHandle,
          title: event.detail?.title || this.currentProductTitle || 'this item',
          image: event.detail?.image || this.currentProductImage,
          imageAlt: event.detail?.imageAlt || this.currentProductImageAlt,
        }, {
          replace: event.detail?.replace === true,
        });
      });
    }

    initializeMediaControls() {
      const canAttachImage = Boolean(this.imageInput && typeof FileReader !== 'undefined' && typeof Image !== 'undefined');
      if (this.cameraButton) {
        this.cameraButton.disabled = !canAttachImage;
        this.cameraButton.setAttribute('aria-label', canAttachImage ? 'Attach photo' : 'Photo upload is not supported in this browser');
      }

      this.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const canDictate = Boolean(this.SpeechRecognition);
      if (this.micButton) {
        this.micButton.disabled = !canDictate;
        this.micButton.setAttribute('aria-label', canDictate ? 'Start voice dictation' : 'Voice dictation is not supported in this browser');
      }
    }

    open() {
      this.syncSelectedVehicle(this.sharedSelectedVehicle());
      document.dispatchEvent(new CustomEvent('jsd:request-close-promo'));
      this.state.open = true;
      this.classList.add('is-open');
      this.launcher.setAttribute('aria-expanded', 'true');
      this.panel.removeAttribute('inert');
      this.panel.setAttribute('aria-hidden', 'false');
      this.syncModalBehavior();
      requestAnimationFrame(() => {
        if (this.state.open) this.input.focus();
      });
    }

    close() {
      this.closeRestartDialog();
      this.state.open = false;
      this.classList.remove('is-open');
      this.launcher.setAttribute('aria-expanded', 'false');
      this.panel.setAttribute('aria-hidden', 'true');
      this.panel.setAttribute('inert', '');
      this.panel.removeAttribute('role');
      this.panel.removeAttribute('aria-modal');
      document.body.classList.remove('jsd-chatbot-open');
      this.launcher.focus();
    }

    syncModalBehavior() {
      if (!this.state.open) return;
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      this.panel.setAttribute('role', mobile ? 'dialog' : 'complementary');
      if (mobile) {
        this.panel.setAttribute('aria-modal', 'true');
        document.body.classList.add('jsd-chatbot-open');
      } else {
        this.panel.removeAttribute('aria-modal');
        document.body.classList.remove('jsd-chatbot-open');
      }
    }

    handleKeydown(event) {
      if (!this.state.open) return;
      if (event.key === 'Escape') {
        if (!this.restartDialog.hidden) {
          this.closeRestartDialog();
          return;
        }
        this.close();
        return;
      }
      if (event.key !== 'Tab' || (this.restartDialog.hidden && window.innerWidth >= MOBILE_BREAKPOINT)) return;
      const focusRoot = this.restartDialog.hidden ? this.panel : this.restartDialog;
      const focusable = [...focusRoot.querySelectorAll('button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')].filter((element) => {
        if (element.tabIndex < 0 || element.closest?.('[hidden], [inert], [aria-hidden="true"]')) return false;
        if (element.getClientRects && !element.getClientRects().length) return false;
        const style = window.getComputedStyle?.(element);
        return !style || (style.visibility !== 'hidden' && style.display !== 'none');
      });
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!focusRoot.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    handleAction(event) {
      const productLink = event.target.closest('.jsd-chatbot__product-link, .jsd-chatbot__comparison-link');
      if (productLink) {
        if (window.innerWidth < MOBILE_BREAKPOINT) this.close();
        return;
      }
      const action = event.target.closest('[data-jsd-action]');
      if (!action) {
        const productCard = event.target.closest('[data-jsd-product-url]');
        const url = safeButtonLink(productCard?.dataset?.jsdProductUrl);
        if (url) {
          if (window.innerWidth < MOBILE_BREAKPOINT) this.close();
          window.location.href = url;
        }
        return;
      }
      const { jsdAction: type, id } = action.dataset;
      if (type === 'vehicle') this.changeView('vehicle');
      if (type === 'fitment') this.changeView('fitment');
      if (type === 'fitment-check') this.submitFitmentCheck();
      if (type === 'fitment-cancel') this.cancelFitmentCheck();
      if (type === 'compare') this.changeView('compare');
      if (type === 'install') this.changeView('install');
      if (type === 'choose-vehicle' || type === 'choose-vehicle-year') this.changeView('vehicle');
      if (type === 'select-product') this.toggleProduct(id);
      if (type === 'compare-selected') this.compareSelected();
      if (type === 'install-topic') this.chooseInstallTopic(id);
      if (type === 'copy-message') this.copyMessage(Number(action.dataset.messageIndex), action);
      if (type === 'reply-message') this.replyToMessage(Number(action.dataset.messageIndex));
      if (type === 'regenerate-message') this.regenerateMessage(Number(action.dataset.messageIndex));
      if (type === 'reference-live-product') {
        this.openWithProductReference({
          handle: action.dataset.productHandle,
          title: action.dataset.productTitle,
          image: action.dataset.productImage,
          imageAlt: action.dataset.productImageAlt,
        });
      }
    }

    handleComposerKeydown(event) {
      if (event.key !== 'Enter' || event.shiftKey) return;
      event.preventDefault();
      if ((this.input.value.trim() || (this.state.imageAttachments || []).length) && !this.pending) {
        this.form.requestSubmit();
      }
    }

    handleCameraClick() {
      if (this.pending || !this.imageInput || this.cameraButton?.disabled) return;
      this.imageInput.click();
    }

    readFileAsDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result || ''));
        reader.onerror = () => reject(reader.error || new Error('Image could not be read.'));
        reader.readAsDataURL(file);
      });
    }

    loadImage(dataUrl) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error('Image could not be loaded.'));
        image.src = dataUrl;
      });
    }

    async prepareImageAttachment(file) {
      if (!file || !/^image\/(?:png|jpe?g|webp|gif)$/i.test(file.type || '')) return null;
      const dataUrl = await this.readFileAsDataUrl(file);
      const image = await this.loadImage(dataUrl);
      const scale = Math.min(1, MAX_IMAGE_DIMENSION / Math.max(image.naturalWidth || image.width, image.naturalHeight || image.height));
      const width = Math.max(1, Math.round((image.naturalWidth || image.width) * scale));
      const height = Math.max(1, Math.round((image.naturalHeight || image.height) * scale));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(image, 0, 0, width, height);
      return normalizeImageAttachment({
        dataUrl: canvas.toDataURL('image/jpeg', IMAGE_QUALITY),
        name: file.name || 'Attached photo',
      });
    }

    async handleImageSelected(event) {
      const file = event.target.files?.[0];
      event.target.value = '';
      if (!file || this.pending) return;
      try {
        const attachment = await this.prepareImageAttachment(file);
        if (!attachment) return;
        this.state.imageAttachments = [attachment].slice(0, MAX_IMAGE_ATTACHMENTS);
        this.saveState();
        this.renderReferences();
        this.updateComposer();
        this.input.focus();
      } catch (error) {
        console.error('JSD chatbot could not attach the image.', error);
      }
    }

    async handleMicClick() {
      if (this.pending || this.micButton?.disabled) return;
      if (this.recognition) {
        this.endDictation();
        return;
      }
      const Recognition = this.SpeechRecognition;
      if (!Recognition) return;
      await this.startAudioMeter();
      const recognition = new Recognition();
      recognition.lang = document.documentElement?.lang || 'en-US';
      recognition.interimResults = true;
      recognition.continuous = true;
      this.pendingDictationText = '';
      this.interimDictationText = '';
      this.dictationStopRequested = false;
      this.isDictating = true;
      recognition.onstart = () => {
        this.recognition = recognition;
        this.classList.add('is-listening');
        if (!this.dictationStartedAt) this.startDictationTimer();
        this.updateComposer();
        this.micButton?.setAttribute('aria-label', 'Stop voice dictation');
      };
      recognition.onresult = (event) => {
        let finalText = '';
        let interimText = '';
        [...event.results].slice(event.resultIndex).forEach((result) => {
          const transcript = result[0]?.transcript || '';
          if (result.isFinal) finalText += ` ${transcript}`;
          else interimText += ` ${transcript}`;
        });
        if (finalText.trim()) {
          this.pendingDictationText = `${this.pendingDictationText || ''} ${finalText}`.trim();
        }
        this.interimDictationText = interimText.trim();
      };
      recognition.onerror = (error) => {
        console.warn('JSD chatbot voice dictation failed.', error);
        if (['not-allowed', 'service-not-allowed'].includes(error?.error)) {
          this.dictationStopRequested = true;
          this.isDictating = false;
        }
      };
      recognition.onend = () => {
        if (!this.dictationStopRequested && this.isDictating) {
          try {
            recognition.start();
          } catch (_error) {
            window.setTimeout(() => {
              if (!this.dictationStopRequested && this.isDictating) {
                try { recognition.start(); } catch (restartError) { console.warn('JSD chatbot could not restart dictation.', restartError); }
              }
            }, 300);
          }
          return;
        }
        this.recognition = null;
        this.isDictating = false;
        this.stopDictationTimer();
        this.stopAudioMeter();
        this.classList.remove('is-listening');
        this.micButton?.setAttribute('aria-label', 'Start voice dictation');
        const finalTranscript = `${this.pendingDictationText || ''} ${this.interimDictationText || ''}`.trim();
        this.pendingDictationText = finalTranscript;
        this.interimDictationText = '';
        if (finalTranscript) {
          this.startDictationTranscribing();
        } else {
          this.updateComposer();
        }
      };
      try {
        recognition.start();
      } catch (error) {
        this.dictationStopRequested = true;
        this.isDictating = false;
        this.stopAudioMeter();
        console.warn('JSD chatbot could not start dictation.', error);
      }
    }

    endDictation() {
      if (!this.recognition) return;
      this.dictationStopRequested = true;
      this.isDictating = false;
      this.recognition.stop();
    }

    async startAudioMeter() {
      this.stopAudioMeter();
      if (!navigator.mediaDevices?.getUserMedia) return;
      try {
        this.audioStream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return;
        this.audioContext = new AudioContextClass();
        this.audioAnalyser = this.audioContext.createAnalyser();
        this.audioAnalyser.fftSize = 512;
        this.audioAnalyser.smoothingTimeConstant = 0.72;
        this.audioSource = this.audioContext.createMediaStreamSource(this.audioStream);
        this.audioSource.connect(this.audioAnalyser);
        this.audioFrequencyData = new Uint8Array(this.audioAnalyser.frequencyBinCount);
        this.updateAudioMeter();
      } catch (error) {
        console.warn('JSD chatbot could not start the audio meter.', error);
      }
    }

    updateAudioMeter() {
      if (!this.audioAnalyser || !this.dictationMeterBars?.length) return;
      this.audioAnalyser.getByteFrequencyData(this.audioFrequencyData);
      const barCount = this.dictationMeterBars.length;
      const binSize = Math.max(1, Math.floor(this.audioFrequencyData.length / barCount));
      this.dictationMeterBars.forEach((bar, index) => {
        const start = index * binSize;
        const slice = this.audioFrequencyData.slice(start, start + binSize);
        const average = slice.reduce((sum, value) => sum + value, 0) / Math.max(1, slice.length);
        const normalized = Math.min(1, Math.max(0.08, average / 180));
        bar.style.height = `${Math.round(6 + normalized * 40)}px`;
      });
      const scheduler = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 80));
      this.audioMeterFrame = scheduler(() => this.updateAudioMeter());
    }

    stopAudioMeter() {
      if (this.audioMeterFrame && window.cancelAnimationFrame) window.cancelAnimationFrame(this.audioMeterFrame);
      else if (this.audioMeterFrame) window.clearTimeout(this.audioMeterFrame);
      this.audioMeterFrame = null;
      this.audioStream?.getTracks?.().forEach((track) => track.stop());
      this.audioStream = null;
      this.audioSource?.disconnect?.();
      this.audioSource = null;
      this.audioContext?.close?.();
      this.audioContext = null;
      this.audioAnalyser = null;
      this.audioFrequencyData = null;
      this.dictationMeterBars?.forEach((bar) => {
        bar.style.height = '';
      });
    }

    formatDictationTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    }

    startDictationTimer() {
      this.dictationStartedAt = Date.now();
      const updateTimer = () => {
        const elapsed = Math.max(0, Math.floor((Date.now() - this.dictationStartedAt) / 1000));
        if (this.dictationTimer) this.dictationTimer.textContent = this.formatDictationTime(elapsed);
      };
      updateTimer();
      window.clearInterval(this.dictationTimerId);
      this.dictationTimerId = window.setInterval(updateTimer, 500);
    }

    stopDictationTimer() {
      window.clearInterval(this.dictationTimerId);
      this.dictationTimerId = null;
      this.dictationStartedAt = null;
    }

    startDictationTranscribing() {
      this.isTranscribingDictation = true;
      this.classList.add('is-transcribing');
      this.updateComposer();
      window.clearTimeout(this.dictationTranscribingTimer);
      this.dictationTranscribingTimer = window.setTimeout(() => {
        const transcript = this.pendingDictationText || '';
        this.pendingDictationText = '';
        this.isTranscribingDictation = false;
        this.classList.remove('is-transcribing');
        if (transcript) {
          const spacer = this.input.value.trim() ? ' ' : '';
          this.input.value = `${this.input.value}${spacer}${transcript}`.slice(0, Number(this.input.maxLength) || 500);
        }
        this.updateComposer();
        this.input.focus();
      }, DICTATION_TRANSCRIBING_MS);
    }

    openRestartDialog() {
      this.restartDialog.hidden = false;
      this.restartCancel.focus();
    }

    closeRestartDialog() {
      if (!this.restartDialog) return;
      this.restartDialog.hidden = true;
      if (this.state?.open) this.restartButton.focus();
    }

    startNewChat() {
      this.fitmentTask = null;
      this.requestController?.abort();
      this.requestController = null;
      this.pending = false;
      this.clearComposerDraft();
      this.state.messages = [];
      this.state.selectedProducts = [];
      this.state.selectedVehicle = this.sharedSelectedVehicle();
      this.state.referenceProducts = [];
      this.state.referenceText = '';
      this.state.imageAttachments = [];
      this.state.openProductLists = [];
      this.clearStoredState();
      this.closeRestartDialog();
      this.render();
      this.input.focus();
    }

    clearComposerDraft() {
      this.input.value = '';
      if (this.imageInput) this.imageInput.value = '';
      window.clearTimeout(this.dictationTranscribingTimer);
      this.pendingDictationText = '';
      this.interimDictationText = '';
      this.isTranscribingDictation = false;
      this.dictationStopRequested = true;
      this.isDictating = false;
      if (this.recognition) {
        this.recognition.onresult = null;
        this.recognition.onend = null;
        this.recognition.abort();
        this.recognition = null;
      }
      this.stopDictationTimer();
      this.stopAudioMeter();
      this.classList?.remove('is-listening', 'is-transcribing');
      this.micButton?.setAttribute('aria-label', this.SpeechRecognition ? 'Start voice dictation' : 'Voice dictation is not supported in this browser');
    }

    async copyMessage(index, button) {
      const message = this.state.messages[index];
      if (message?.sender !== 'ai' || !message.text) return;
      try {
        await navigator.clipboard.writeText(plainMessageText(message.text));
        button.setAttribute('aria-label', 'Copied');
        button.classList.add('is-confirmed');
        window.setTimeout(() => {
          button.setAttribute('aria-label', 'Copy response');
          button.classList.remove('is-confirmed');
        }, 1500);
      } catch (error) {
        console.error('JSD chatbot could not copy the response.', error);
      }
    }

    replyToMessage(index) {
      const message = this.state.messages[index];
      if (message?.sender !== 'ai' || !message.text) return;
      this.state.referenceText = plainMessageText(message.text).slice(0, 1000);
      this.saveState();
      this.renderReferences();
      this.input.focus();
    }

    changeView(view) {
      if (view === 'fitment') {
        this.beginFitmentCheck();
        return;
      }
      if (view === 'vehicle') {
        this.openVehicleSelector();
        return;
      }

      const prompts = {
        compare: 'I want to compare products.',
        install: 'I need installation help.',
      };
      if (!prompts[view]) return;
      this.fitmentTask = null;
      this.input.value = prompts[view];
      this.updateComposer();
      this.form.requestSubmit();
    }

    beginFitmentCheck() {
      if (this.pending) return;
      if (!this.state.referenceProducts.length && this.currentProductHandle) {
        this.state.referenceProducts = [normalizeReferenceProduct({
          handle: this.currentProductHandle, title: this.currentProductTitle || 'This product',
          image: this.currentProductImage || '',
        })].filter(Boolean);
      }
      if (!this.fitmentTask) {
        const id = (this.fitmentSequence || 0) + 1;
        this.fitmentSequence = id;
        this.fitmentTask = { id, query: '', year: '', trim: '', error: '' };
      }
      if (!this.state.messages.some(entry => entry.type === 'fitment-setup' && entry.fitmentId === this.fitmentTask.id)) {
        this.state.messages.push({ type: 'fitment-setup', fitmentId: this.fitmentTask.id });
      }
      this.render();
    }

    cancelFitmentCheck() {
      this.fitmentTask = null;
      this.render();
      this.input.focus();
    }

    submitFitmentCheck() {
      const task = this.fitmentTask;
      if (!task || this.pending) return;
      task.error = '';
      const references = (this.state.referenceProducts || []).map(normalizeReferenceProduct).filter(Boolean);
      const query = task.query.trim();
      if (!references.length && !query) {
        task.error = 'Choose a product using Ask AI, or enter its name or link below.';
      } else if (!this.state.selectedVehicle) {
        this.openVehicleSelector();
        return;
      } else if (!/^\d{4}$/.test(task.year.trim()) || Number(task.year) < 1900 || Number(task.year) > new Date().getFullYear() + 2) {
        task.error = 'Enter your exact four-digit model year. A selection such as 2024+ is a range, not a confirmed fit.';
      }
      if (task.error) {
        this.render();
        return;
      }
      const vehicle = this.state.selectedVehicle;
      // Freeze explicit scope so request construction cannot choose old chat cards.
      const scopedTask = { ...task, references, vehicle: { ...vehicle } };
      const message = `Please check vehicle compatibility for ${references.length ? 'the selected product' + (references.length > 1 ? 's' : '') : query} with my ${task.year.trim()} ${vehicle.model}${task.trim.trim() ? ` (${task.trim.trim()})` : ''}? Please explain using the listing details.`;
      const draft = this.input.value;
      this.fitmentTask = null;
      this.fitmentSubmission = scopedTask;
      this.input.value = message;
      this.form.requestSubmit();
      this.fitmentSubmission = null;
      this.input.value = draft;
      this.updateComposer();
    }

    renderFitmentSetup(entry) {
      const task = this.fitmentTask;
      if (!task || entry.fitmentId !== task.id) return '<p class="jsd-chatbot__fitment-closed">Fitment setup closed.</p>';
      const references = (this.state.referenceProducts || []).map(normalizeReferenceProduct).filter(Boolean);
      const vehicle = this.state.selectedVehicle;
      const prefix = `jsd-fitment-${task.id}`;
      return `<section class="jsd-chatbot__fitment-setup" aria-label="Check product fitment">
        <h4>Check Product Fitment</h4>
        <p>We’ll check the listing’s requirements. Selecting a vehicle alone doesn’t confirm fitment.</p>
        ${references.length ? `<p><strong>${references.length === 1 ? 'Product' : 'Products'}:</strong> ${references.map(p => escapeHtml(p.title)).join('; ')}</p>` : `<label for="${prefix}-query">Product name or link</label><input id="${prefix}-query" data-fitment-field="query" type="text" maxlength="500" value="${escapeHtml(task.query)}" placeholder="Or select products using Ask AI">`}
        <p><strong>Vehicle:</strong> ${vehicle ? escapeHtml(`${vehicle.model} ${vehicle.year}`.trim()) : 'Not selected'}</p>
        <button type="button" class="jsd-chatbot__button-secondary" data-jsd-action="vehicle">${vehicle ? 'Change vehicle' : 'Choose vehicle'}</button>
        ${vehicle ? `<label for="${prefix}-year">Exact model year</label><input id="${prefix}-year" data-fitment-field="year" type="text" inputmode="numeric" maxlength="4" value="${escapeHtml(task.year)}" placeholder="e.g. 2024"><label for="${prefix}-trim">Trim / package (if known)</label><input id="${prefix}-trim" data-fitment-field="trim" type="text" maxlength="120" value="${escapeHtml(task.trim)}" placeholder="e.g. EcoBoost, without Performance Pack">` : ''}
        ${task.error ? `<p class="jsd-chatbot__fitment-error" role="alert">${escapeHtml(task.error)}</p>` : ''}
        <div class="jsd-chatbot__fitment-actions"><button type="button" class="jsd-chatbot__button-primary" data-jsd-action="fitment-check">${vehicle ? 'Check fitment' : 'Continue'}</button><button type="button" class="jsd-chatbot__button-secondary" data-jsd-action="fitment-cancel">Cancel</button></div>
      </section>`;
    }

    openVehicleSelector() {
      const selector = document.querySelector('jsd-vehicle-selector');
      if (!selector?.initialized || typeof selector.open !== 'function' || !selector.families?.length) {
        this.state.messages.push({
          sender: 'ai',
          text: 'Vehicle selection is unavailable right now. You can keep chatting, or refresh the page to try again.',
          suppressActions: true,
        });
        this.saveState();
        this.render();
        return;
      }
      this.returnFromVehicleSelector = true;
      this.close();
      selector.open(this.vehicleBanner, { source: 'chatbot', startOver: true });
    }

    handleVehicleSelectorClose(event) {
      if (event.detail?.source !== 'chatbot' || !this.returnFromVehicleSelector) return;
      this.returnFromVehicleSelector = false;
      this.syncSelectedVehicle(event.detail.vehicle);
      const vehicle = this.state.selectedVehicle;
      if (this.fitmentTask) {
        if (event.detail.reason !== 'selected') this.fitmentTask.error = 'Vehicle selection was cancelled. No fitment check was sent.';
        else this.fitmentTask.error = '';
        this.render();
      } else if (event.detail.reason === 'selected' && vehicle) {
        this.state.messages.push({
          sender: 'ai',
          text: `Your vehicle is now ${vehicle.model}${vehicle.year ? ` ${vehicle.year}` : ''}. I’ll use it for fitment checks and product searches.`,
          suppressActions: true,
        });
        this.saveState();
        this.render();
      }
      // Reopen after the selector's Escape/click event has finished propagating.
      requestAnimationFrame(() => this.open());
    }

    sharedSelectedVehicle() {
      try {
        const shared = typeof window.JsdVehicle?.get === 'function'
          ? window.JsdVehicle.get()
          : JSON.parse(this.sharedStorage()?.getItem('jsd-selected-vehicle') || 'null');
        return this.normalizeSelectedVehicle(shared);
      } catch (error) {
        return null;
      }
    }

    normalizeSelectedVehicle(vehicle) {
      if (!vehicle || typeof vehicle !== 'object') return null;
      const model = String(vehicle.model || vehicle.title || '').trim();
      if (!Object.hasOwn(vehicleYears, model)) return null;
      const year = String(vehicle.year || '').trim();
      const validYears = vehicleYears[model] || [];
      if (year && !validYears.includes(year)) return null;
      return { model, year };
    }

    syncSelectedVehicle(vehicle) {
      const normalized = this.normalizeSelectedVehicle(vehicle);
      if (JSON.stringify(normalized) === JSON.stringify(this.state.selectedVehicle || null)) return;
      if (this.fitmentTask) {
        this.fitmentTask.year = '';
        this.fitmentTask.trim = '';
      }
      this.state.selectedVehicle = normalized;
      this.vehicleContextVersion = (this.vehicleContextVersion || 0) + 1;
      if (this.pending) {
        this.requestController?.abort();
        this.requestController = null;
        this.pending = false;
        this.state.messages.forEach((entry) => {
          if (!entry.pending) return;
          delete entry.pending;
          entry.text = 'Your vehicle changed while I was answering. Please send your question again so I can use the updated selection.';
          entry.suppressActions = true;
          delete entry.products;
        });
      }
      this.saveState();
      this.render();
    }

    toggleProduct(id) {
      if (!products.some((product) => product.id === id)) return;
      const selected = this.state.selectedProducts;
      const index = selected.indexOf(id);
      if (index >= 0) selected.splice(index, 1);
      else if (selected.length < 4) selected.push(id);
      this.saveState();
      this.render();
    }

    compareSelected() {
      const selected = products.filter((product) => this.state.selectedProducts.includes(product.id));
      if (selected.length < 2) return;
      this.state.messages.push(
        { sender: 'user', text: `Compare ${selected.map((product) => product.title).join(' and ')}` },
        { sender: 'ai', text: `${selected[0].title} is the lower-cost appearance upgrade at ${selected[0].price}. ${selected[1].title} changes a different area of the vehicle and uses ${selected[1].material}. Both mock products fit the 2024+ Mustang, so the best choice depends on whether you want lighting-area styling or a more substantial exterior modification.` },
      );
      this.saveState();
      this.render();
    }

    chooseInstallTopic(topic) {
      const guides = {
        preparation: 'Clean and fully dry the headlight lenses, then test-fit both covers before removing any protective backing.',
        mounting: 'Align each cover from the outer edge inward, apply light even pressure, and verify that no lighting or ventilation opening is obstructed.',
        care: 'Allow the mounting surface to set for 24 hours. Hand-wash with mild soap and avoid abrasive cleaners.',
      };
      const text = guides[topic] || guides.preparation;
      this.state.messages.push(
        { sender: 'user', text: `Installation help: ${topic}` },
        { sender: 'ai', text: `Prototype guidance: ${text} Always follow the final manufacturer instructions supplied with the production item.` },
      );
      this.saveState();
      this.render();
    }

    openWithProduct(product) {
      this.state.selectedProducts = [product.id];
      this.state.messages.push(
        { sender: 'ai', text: `You selected ${product.title}. What would you like to know about compatibility, materials, styling, or installation?` },
      );
      this.saveState();
      this.render();
      this.open();
    }

    openWithProductReference(product, options = {}) {
      const reference = normalizeReferenceProduct(product);
      if (!reference) return;
      const references = Array.isArray(this.state.referenceProducts) ? this.state.referenceProducts : [];
      if (options.replace) {
        this.state.referenceProducts = [reference];
        this.saveState();
        this.render();
        this.open();
        return;
      }
      const index = references.findIndex((item) => item.handle === reference.handle);
      if (index >= 0) {
        references.splice(index, 1);
        this.state.referenceProducts = references;
        this.saveState();
        this.render();
        return;
      }
      if (references.length < 4) references.push(reference);
      this.state.referenceProducts = references;
      this.saveState();
      this.render();
      this.open();
    }

    handleProductListToggle(event) {
      const details = event.target.closest?.('.jsd-chatbot__more-products');
      const key = details?.dataset?.productListKey;
      if (!key) return;
      const openLists = Array.isArray(this.state.openProductLists) ? this.state.openProductLists : [];
      if (details.open) {
        if (!openLists.includes(key)) openLists.push(key);
      } else {
        const index = openLists.indexOf(key);
        if (index >= 0) openLists.splice(index, 1);
      }
      this.state.openProductLists = openLists;
      this.saveState();
    }

    handleRemoveSelection(event) {
      const referenceProduct = event.target.closest('[data-reference-product]');
      if (referenceProduct) {
        this.state.referenceProducts = (this.state.referenceProducts || [])
          .filter((product) => product.handle !== referenceProduct.dataset.productHandle);
        this.saveState();
        this.render();
        return;
      }
      if (event.target.closest('[data-reference-text]')) {
        this.state.referenceText = '';
        this.saveState();
        if (this.fitmentTask) this.render();
        else this.renderReferences();
        return;
      }
      if (event.target.closest('[data-image-attachment]')) {
        this.state.imageAttachments = [];
        this.saveState();
        this.renderReferences();
        this.updateComposer();
        return;
      }
      const button = event.target.closest('[data-product-id]');
      if (!button) return;
      this.state.selectedProducts = this.state.selectedProducts.filter((id) => id !== button.dataset.productId);
      this.saveState();
      this.render();
    }

    messageHistory(entries = this.state.messages) {
      return entries.flatMap((entry) => {
        if (!entry.sender || !entry.text || entry.pending) return [];
        const referencedProducts = Array.isArray(entry.products) ? entry.products : [];
        const productContext = referencedProducts.map(normalizeReferenceProduct).filter(Boolean).slice(0, 4)
          .map((product) => ({ handle: product.handle, title: product.title }));
        const selectedIdentity = entry.sender !== 'ai' && entry.requestContext?.productHandles?.length
          ? `\nProducts referenced by this customer message (identifiers): ${JSON.stringify(entry.requestContext.productHandles)}` : '';
        const identity = productContext.length ? `\nProducts shown with this message (identifiers, not independent factual evidence): ${JSON.stringify(productContext)}` : '';
        return [{ role: entry.sender === 'ai' ? 'assistant' : 'user', content: entry.text + identity + selectedIdentity }];
      });
    }

    selectedProductContextMessage(productsToDescribe = []) {
      const productsForContext = productsToDescribe
        .map(normalizeReferenceProduct)
        .filter(Boolean)
        .slice(0, 4);
      if (!productsForContext.length) return '';
      return `Selected product reference${productsForContext.length === 1 ? '' : 's'}: ${productsForContext
        .map((product, index) => `${index + 1}. ${product.title} (handle: ${product.handle})`)
        .join(' | ')}`;
    }

    recentProductContext(message = '') {
      if (!hasContextualProductFollowup(message)) return [];
      const messages = Array.isArray(this.state.messages) ? this.state.messages : [];
      if (/\bgo back\b.{0,30}\bfirst\b/i.test(message)) {
        const original = messages.find((entry) => entry.products?.length);
        if (original) return original.products.slice(0, 1).map(normalizeReferenceProduct).filter(Boolean);
      }
      if (/\b(?:cheaper|less expensive|shortlist|we (?:chose|decided))\b|\bwhy\b.{0,55}\b(?:more expensive|cost more)\b|\bwhich\b.{0,30}\b(?:better|pick)\b/i.test(message)) {
        const recent = [];
        for (const entry of [...messages].reverse()) {
          for (const product of entry.products || []) {
            if (!recent.some((item) => item.handle === product.handle)) recent.unshift(product);
          }
          if (recent.length >= 2) break;
        }
        if (recent.length >= 2) return recent.slice(-4).map(normalizeReferenceProduct).filter(Boolean);
      }
      const correction = /\b(?:already|as I|there (?:are|were)|you(?: are|'re)? wrong|two|both|first one|other one)\b/i.test(message);
      if (/\b(?:what was the first|first one called)\b/i.test(message)) {
        const original = messages.find((entry) => entry.products?.length > 1);
        if (original) return original.products.map(normalizeReferenceProduct).filter(Boolean).slice(0, 4);
      }
      if (/\b(?:first|second|little|smaller)\b|\bbetter\b.{0,40}\bthan\b/i.test(message)) {
        const group = [...messages].reverse().find((entry) => entry.products?.length > 1);
        if (group) return group.products.map(normalizeReferenceProduct).filter(Boolean).slice(0, 4);
      }
      if (correction) {
        const comparison = [...messages].reverse().find((entry) => Array.isArray(entry.products) && entry.products.length > 1
          && /compare|comparison|differences|listing differences/i.test(entry.text || ''));
        if (comparison) return comparison.products.map(normalizeReferenceProduct).filter(Boolean).slice(0, 4);
        // Corrections can refer to two separately inspected items even before
        // a comparison module exists. Reuse their real request identities.
        const shown = new Map(messages.flatMap((entry) => Array.isArray(entry.products) ? entry.products : [])
          .map(normalizeReferenceProduct).filter(Boolean).map((product) => [product.handle, product]));
        const focused = [];
        for (const entry of [...messages].reverse()) {
          if (entry.sender !== 'user') continue;
          for (const handle of entry.requestContext?.productHandles || []) {
            const product = shown.get(handle);
            if (product && !focused.some((item) => item.handle === handle)) focused.unshift(product);
          }
          if (focused.length >= 2) break;
        }
        if (focused.length >= 2) return focused.slice(0, 4);
      }
      for (let index = messages.length - 1; index >= 0; index -= 1) {
        const productsFromMessage = Array.isArray(messages[index]?.products)
          ? messages[index].products.map(normalizeReferenceProduct).filter(Boolean)
          : [];
        if (productsFromMessage.length) return productsFromMessage.slice(0, 4);
      }
      return [];
    }

    selectedVehicleContextMessage(vehicleToDescribe = null) {
      const vehicle = this.normalizeSelectedVehicle(vehicleToDescribe);
      if (!vehicle) return '';
      return `Selected customer vehicle for this chat: ${vehicle.model}${vehicle.year ? ` ${vehicle.year}` : ''}`;
    }

    productHandlesForRequest(message = '') {
      const liveReferenceHandles = [];
      const addReferenceHandle = (handle) => {
        const cleanHandle = sanitizeHandle(handle);
        if (cleanHandle && !liveReferenceHandles.includes(cleanHandle)) liveReferenceHandles.push(cleanHandle);
      };
      (this.state.referenceProducts || []).forEach((product) => addReferenceHandle(product?.handle));

      const selectedHandles = [];
      this.state.selectedProducts.forEach((id) => {
        const product = products.find((item) => item.id === id);
        const cleanHandle = sanitizeHandle(product?.handle);
        if (cleanHandle && !selectedHandles.includes(cleanHandle)) selectedHandles.push(cleanHandle);
      });
      if (liveReferenceHandles.length) {
        return [...new Set([...liveReferenceHandles, ...selectedHandles])].slice(0, 4);
      }

      this.recentProductContext(message).forEach((product) => addReferenceHandle(product?.handle));
      if (liveReferenceHandles.length) return liveReferenceHandles.slice(0, 4);

      const handles = new Set();
      if (this.currentProductHandle && !hasNewProductSearchIntent(message)) {
        handles.add(this.currentProductHandle);
      }
      selectedHandles.forEach((handle) => handles.add(handle));
      return [...handles].slice(0, 4);
    }

    messageReferencePreviews() {
      const previews = [];
      const addPreview = (product) => {
        if (!product) return;
        const handle = sanitizeHandle(product.handle);
        const title = String(product.title || 'Selected item').trim();
        const image = product.image || '';
        const key = handle || title;
        if (!key || previews.some((preview) => preview.key === key)) return;
        previews.push({
          key,
          title,
          image,
          imageAlt: String(product.imageAlt || title).trim(),
        });
      };

      (this.state.referenceProducts || []).forEach(addPreview);
      this.state.selectedProducts.forEach((id) => {
        const product = products.find((item) => item.id === id);
        if (!product) return;
        addPreview({
          handle: product.handle,
          title: product.title,
          image: this.asset(product.image),
          imageAlt: product.title,
        });
      });
      return previews.slice(0, 4).map(({ key: _key, ...preview }) => preview);
    }

    requestHistoryForCurrentReferences(message = '') {
      const history = this.messageHistory();
      if (this.state.referenceText) {
        history.push(
          { role: 'user', content: `Quoted earlier assistant message for my next question (it may be incorrect; recheck it against current product evidence): ${this.state.referenceText}` },
        );
      }
      const selectedProductContext = this.selectedProductContextMessage(this.state.referenceProducts);
      if (selectedProductContext) {
        history.push(
          { role: 'assistant', content: selectedProductContext },
          { role: 'user', content: 'My next question refers specifically to the selected product reference above.' },
        );
      }
      if (!selectedProductContext) {
        const recentProductContext = this.selectedProductContextMessage(this.recentProductContext(message));
        if (recentProductContext) {
          history.push(
            { role: 'assistant', content: recentProductContext },
            { role: 'user', content: 'My next question refers to the most recently shown product cards above.' },
          );
        }
      }
      const selectedVehicleContext = this.selectedVehicleContextMessage(this.state.selectedVehicle);
      if (selectedVehicleContext) {
        history.push(
          { role: 'assistant', content: selectedVehicleContext },
          { role: 'user', content: 'Use the selected customer vehicle context when checking fitment or narrowing product searches.' },
        );
      }
      return history;
    }

    async submitMessage(event) {
      event.preventDefault();
      const attachments = (this.state.imageAttachments || [])
        .map(normalizeImageAttachment)
        .filter(Boolean)
        .slice(0, MAX_IMAGE_ATTACHMENTS);
      const text = this.input.value.trim() || (attachments.length ? 'Please help with this photo.' : '');
      if (!text || this.pending) return;
      const history = this.requestHistoryForCurrentReferences(text);
      const requestContext = {
        productIds: [...this.state.selectedProducts],
        productHandles: this.productHandlesForRequest(text),
        selectedVehicle: this.state.selectedVehicle || null,
        images: attachments.map((attachment) => ({
          dataUrl: attachment.dataUrl,
          name: attachment.name,
        })),
      };
      if (this.fitmentSubmission) {
        requestContext.productIds = [];
        requestContext.productHandles = this.fitmentSubmission.references.map(product => product.handle);
        requestContext.selectedVehicle = this.fitmentSubmission.vehicle;
      }
      const references = this.messageReferencePreviews();
      const imageReferences = attachments.map((attachment) => ({
        dataUrl: attachment.dataUrl,
        name: attachment.name,
        imageAlt: attachment.imageAlt || attachment.name || 'Reference image',
      }));
      const replyReference = this.state.referenceText
        ? plainMessageText(this.state.referenceText).slice(0, 180)
        : '';

      this.state.messages.push({
        sender: 'user',
        text,
        references,
        imageReferences,
        replyReference,
        requestHistory: history,
        requestContext,
      });
      this.fitmentTask = null;
      this.state.referenceText = '';
      this.state.referenceProducts = [];
      this.state.selectedProducts = [];
      this.state.imageAttachments = [];
      this.input.value = '';
      this.updateComposer();
      this.saveState();

      if (!this.apiUrl) {
        this.state.messages.push({ sender: 'ai', text: this.scriptedResponse() });
        this.saveState();
        this.render();
        return;
      }

      const pendingMessage = {
        sender: 'ai',
        text: 'Thinking...',
        pending: true,
        requestHistory: history,
        requestContext,
      };
      this.state.messages.push(pendingMessage);
      await this.resolveAiMessage(text, history, pendingMessage, requestContext);
    }

    async regenerateMessage(index) {
      if (this.pending) return;
      if (this.state.messages[index]?.sender !== 'ai') return;
      let userIndex = index - 1;
      while (userIndex >= 0 && this.state.messages[userIndex].sender !== 'user') userIndex -= 1;
      if (userIndex < 0) return;

      const text = this.state.messages[userIndex].text;
      const previousAiMessage = this.state.messages[index];
      const userMessage = this.state.messages[userIndex];
      let history = Array.isArray(previousAiMessage.requestHistory)
        ? previousAiMessage.requestHistory
        : Array.isArray(userMessage.requestHistory)
          ? userMessage.requestHistory
          : this.messageHistory(this.state.messages.slice(0, userIndex));
      const originalContext = previousAiMessage.requestContext || userMessage.requestContext || {};
      const selectedVehicle = this.state.selectedVehicle || null;
      const requestContext = { ...originalContext, selectedVehicle };
      if (JSON.stringify(originalContext.selectedVehicle || null) !== JSON.stringify(selectedVehicle)) {
        history = history.filter((entry) => (
          !entry.content.startsWith('Selected customer vehicle for this chat:')
          && entry.content !== 'Use the selected customer vehicle context when checking fitment or narrowing product searches.'
        ));
        const context = this.selectedVehicleContextMessage(selectedVehicle);
        if (context) history = [...history, { role: 'assistant', content: context }];
      }
      const pendingMessage = {
        sender: 'ai',
        text: 'Thinking...',
        pending: true,
        requestHistory: history,
        requestContext,
      };
      this.state.messages[index] = pendingMessage;
      await this.resolveAiMessage(text, history, pendingMessage, requestContext);
    }

    async resolveAiMessage(text, history, pendingMessage, requestContext = {}) {
      this.pending = true;
      this.userScrolledDuringReply = false;
      this.render();

      if (!this.apiUrl) {
        pendingMessage.text = this.scriptedResponse();
        delete pendingMessage.pending;
        this.pending = false;
        this.saveState();
        this.render();
        return;
      }

      const controller = new AbortController();
      const vehicleVersion = this.vehicleContextVersion || 0;
      this.requestController = controller;
      const timeout = window.setTimeout(() => controller.abort(), 25000);

      try {
        const response = await fetch(this.apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: text,
            history,
            productIds: requestContext.productIds || this.state.selectedProducts,
            productHandles: requestContext.productHandles || this.productHandlesForRequest(text),
            selectedVehicle: Object.hasOwn(requestContext, 'selectedVehicle')
              ? requestContext.selectedVehicle : this.state.selectedVehicle || null,
            images: requestContext.images || [],
          }),
          signal: controller.signal,
        });
        const body = await response.json().catch(() => ({}));
        if (vehicleVersion !== (this.vehicleContextVersion || 0) || this.requestController !== controller) return;
        if (!response.ok || !body.answer) throw new Error(body.error || 'Chat request failed.');
        pendingMessage.text = body.answer;
        pendingMessage.products = Array.isArray(body.products) ? body.products.slice(0, 7) : [];
      } catch (error) {
        if (vehicleVersion !== (this.vehicleContextVersion || 0) || this.requestController !== controller) return;
        console.error('JSD chatbot request failed.', error);
        pendingMessage.text = error.name === 'AbortError'
          ? 'The assistant is taking too long to respond. Please try again.'
          : 'The assistant is temporarily unavailable. Please try again.';
        pendingMessage.error = true;
      } finally {
        window.clearTimeout(timeout);
        if (this.requestController === controller) {
          this.requestController = null;
          delete pendingMessage.pending;
          this.pending = false;
          this.saveState();
          this.render();
          if (this.state.open) this.input.focus();
        }
      }
    }

    scriptedResponse() {
      return this.state.selectedProducts.length
        ? 'For this front-end prototype, I have kept your selected mock products attached as context. Configure the secured backend endpoint to generate a product-specific answer.'
        : 'This is a scripted prototype response. Configure the secured backend endpoint to enable AI answers.';
    }

    updateComposer() {
      const active = Boolean(this.input.value.trim() || (this.state.imageAttachments || []).length);
      this.classList?.toggle('has-message', active);
      this.classList?.toggle('is-pending', this.pending);
      this.classList?.toggle('is-dictating', Boolean(this.recognition));
      this.classList?.toggle('is-transcribing', Boolean(this.isTranscribingDictation));
      if (this.dictation) this.dictation.hidden = !this.recognition && !this.isTranscribingDictation;
      this.input.disabled = this.pending || this.recognition || this.isTranscribingDictation;
      if (this.sendButton) this.sendButton.disabled = !active || this.pending || this.isTranscribingDictation;
      if (this.cameraButton) this.cameraButton.disabled = this.pending || !(this.imageInput && typeof FileReader !== 'undefined');
      if (this.micButton) this.micButton.disabled = this.pending || this.isTranscribingDictation || !this.SpeechRecognition;
      this.syncComposerHeight();
    }

    syncComposerHeight() {
      if (!this.input || this.input.tagName !== 'TEXTAREA') return;
      this.input.style.height = 'auto';
      const maxHeight = COMPOSER_LINE_HEIGHT * COMPOSER_MAX_LINES;
      const nextHeight = Math.min(this.input.scrollHeight, maxHeight);
      this.input.style.height = `${Math.max(COMPOSER_LINE_HEIGHT, nextHeight)}px`;
      this.input.style.overflowY = this.input.scrollHeight > maxHeight ? 'auto' : 'hidden';
    }

    asset(name) {
      const url = `${this.assetBase}${name}`;
      return /\.svg$/i.test(name) ? `${url}?v=${ICON_ASSET_VERSION}` : url;
    }

    notifyReferenceProductsChanged() {
      const EventConstructor = window.CustomEvent || globalThis.CustomEvent;
      if (!EventConstructor || typeof document.dispatchEvent !== 'function') return;
      document.dispatchEvent(new EventConstructor('jsd-chatbot:reference-products-change', {
        detail: {
          handles: (this.state.referenceProducts || []).map((product) => product?.handle).filter(Boolean),
        },
      }));
    }

    render() {
      const nextMessageCount = this.state.messages.length;
      const hasPendingReply = this.state.messages.some((entry) => entry.pending);
      const replyCompleted = this.renderedPendingReply && !hasPendingReply;
      const shouldScroll = nextMessageCount > (this.renderedMessageCount || 0)
        || (replyCompleted && !this.userScrolledDuringReply);
      this.renderTranscript();
      this.renderReferences();
      this.renderVehicleBanner();
      this.updateComposer();
      this.notifyReferenceProductsChanged();
      this.renderedMessageCount = nextMessageCount;
      this.renderedPendingReply = hasPendingReply;
      if (shouldScroll) afterPaint(() => this.scrollLatestEntryToTop());
    }

    scrollLatestEntryToTop() {
      const entries = this.messages.querySelectorAll('[data-jsd-transcript-entry]');
      const latest = entries[entries.length - 1];
      if (!latest) return;
      const viewport = this.messages.getBoundingClientRect();
      const entry = latest.getBoundingClientRect();
      this.messages.scrollTop = Math.max(0, this.messages.scrollTop + entry.top - viewport.top - (this.messages.clientTop || 0) - 8);
    }

    renderWelcome() {
      return `
        <div class="jsd-chatbot__welcome">
          <div class="jsd-chatbot__welcome-icon"><img src="${this.asset('jsd-chatbot-ai-icon.svg')}" alt=""></div>
          <h3>How Can I Help?</h3>
          <div class="jsd-chatbot__quick-actions">
            <button class="jsd-chatbot__quick-action" type="button" data-jsd-action="fitment"><img src="${this.asset(icons.vehicle)}" alt=""><span>Check Product Fitment</span></button>
            <button class="jsd-chatbot__quick-action" type="button" data-jsd-action="compare"><img src="${this.asset(icons.compare)}" alt=""><span>Compare Products</span></button>
            <button class="jsd-chatbot__quick-action" type="button" data-jsd-action="install"><img src="${this.asset(icons.install)}" alt=""><span>Installation Help</span></button>
          </div>
        </div>`;
    }

    renderVehicleBanner() {
      if (!this.vehicleBanner || !this.vehicleBannerText) return;
      const vehicle = this.normalizeSelectedVehicle(this.state.selectedVehicle);
      const bannerVehicle = vehicle
        ? `${vehicle.year ? `${vehicle.year} ` : ''}${vehicle.model.replace(/^Ford\s+/i, '')}`
        : '';
      this.vehicleBanner.classList.toggle('is-selected', Boolean(vehicle));
      this.vehicleBannerText.textContent = vehicle
        ? `Your Vehicle: ${bannerVehicle}`
        : 'Find Parts For Your Vehicle';
      if (this.vehicleBannerAction) {
        this.vehicleBannerAction.src = this.asset(vehicle ? 'jsd-chatbot-change.svg' : 'jsd-chatbot-next.svg');
      }
      const label = vehicle ? `Change selected vehicle: ${this.vehicleBannerText.textContent}` : 'Find parts for your vehicle';
      const tooltip = vehicle ? 'Change vehicle' : 'Find parts for your vehicle';
      this.vehicleBanner.setAttribute('aria-label', label);
      if (this.vehicleBannerActionWrap) {
        this.vehicleBannerActionWrap.setAttribute('data-jsd-tooltip', tooltip);
      }
    }

    renderTranscript() {
      this.messages.innerHTML = this.state.messages.length
        ? `<div class="jsd-chatbot__transcript">${this.state.messages.map((entry, index) => `<div class="jsd-chatbot__transcript-entry" data-jsd-transcript-entry data-jsd-entry-index="${index}">${this.renderEntry(entry, index)}</div>`).join('')}</div>`
        : this.renderWelcome();
    }

    renderEntry(entry, index) {
      if (entry.type === 'fitment-setup') return this.renderFitmentSetup(entry);
      if (entry.sender === 'user') {
        const references = Array.isArray(entry.references) ? entry.references : [];
        const imageReferences = Array.isArray(entry.imageReferences) ? entry.imageReferences : [];
        const replyReference = typeof entry.replyReference === 'string' && entry.replyReference.trim()
          ? `<div class="jsd-chatbot__user-reply-reference" aria-label="Referenced assistant message"><span>${escapeHtml(entry.replyReference)}</span></div>`
          : '';
        const referencePreview = references.length ? `<div class="jsd-chatbot__user-references" aria-label="${references.length} referenced item${references.length === 1 ? '' : 's'}">
          <div class="jsd-chatbot__user-reference-images">
            ${references.slice(0, 3).map((reference) => `
              <span class="jsd-chatbot__user-reference-thumb">
                <img src="${escapeHtml(safeLink(reference.image) || this.asset('jsd-chatbot-product.png'))}" alt="${escapeHtml(reference.imageAlt || reference.title || '')}">
              </span>`).join('')}
          </div>
          <span class="jsd-chatbot__user-reference-count">${references.length} item${references.length === 1 ? '' : 's'}</span>
        </div>` : '';
        const imagePreview = imageReferences.length ? `<div class="jsd-chatbot__user-image-references" aria-label="${imageReferences.length} reference image${imageReferences.length === 1 ? '' : 's'}">
          ${imageReferences.slice(0, MAX_IMAGE_ATTACHMENTS).map((reference) => `
            <span class="jsd-chatbot__user-image-reference">
              <img src="${escapeHtml(reference.dataUrl || reference.image || '')}" alt="${escapeHtml(reference.imageAlt || reference.name || 'Reference image')}">
            </span>`).join('')}
        </div>` : '';
        return `<div class="jsd-chatbot__user-entry">
          <div class="jsd-chatbot__user-message"><p>${escapeHtml(entry.text)}</p></div>
          ${replyReference}${referencePreview}${imagePreview}
        </div>`;
      }
      if (entry.sender === 'ai') {
        if (entry.pending) {
          return `<div class="jsd-chatbot__ai-message is-pending"><span class="jsd-chatbot__ai-dot"></span><span>Thinking</span></div>`;
        }
        const content = renderLimitedMarkdown(entry.text);
        const actions = entry.error || entry.suppressActions ? '' : `<div class="jsd-chatbot__message-actions">
          <button type="button" data-jsd-action="copy-message" data-message-index="${index}" aria-label="Copy response" data-jsd-tooltip="Copy"><img src="${this.asset('jsd-chatbot-copy.svg')}" alt=""></button>
          <button type="button" data-jsd-action="reply-message" data-message-index="${index}" aria-label="Reply to response" data-jsd-tooltip="Reply"><img src="${this.asset('jsd-chatbot-reply.svg')}" alt=""></button>
          <button type="button" data-jsd-action="regenerate-message" data-message-index="${index}" aria-label="Regenerate response" data-jsd-tooltip="Regenerate"><img src="${this.asset('jsd-chatbot-regenerate.svg')}" alt=""></button>
        </div>`;
        const link = content.link
          ? `<a class="jsd-chatbot__button-primary jsd-chatbot__message-link" href="${escapeHtml(content.link.url)}" target="_blank" rel="noopener noreferrer">${escapeHtml(content.link.label)}</a>`
          : '';
        const liveProducts = Array.isArray(entry.products) && entry.products.length
          ? this.liveProductList(entry.products, index)
          : '';
        return `<div class="jsd-chatbot__ai-message${entry.error ? ' is-error' : ''}">
          <div class="jsd-chatbot__message-content">${content.html}</div>
          ${actions}${liveProducts}${link}
        </div>`;
      }
      if (entry.type === 'vehicle-grid' || entry.type === 'vehicle-year-grid') return '';
      if (entry.type === 'product-list') {
        return `<div class="jsd-chatbot__product-list">${products.map((product) => this.productCard(product)).join('')}</div>
          <button class="jsd-chatbot__accent-button" type="button" data-jsd-action="compare-selected" ${this.state.selectedProducts.length < 2 ? 'disabled' : ''}>Compare selected products</button>`;
      }
      if (entry.type === 'product-detail') {
        const product = products.find((item) => item.id === entry.productId) || products[0];
        return this.productCard(product);
      }
      if (entry.type === 'install-options') {
        return `<div class="jsd-chatbot__topic-list">
          <button class="jsd-chatbot__accent-button" type="button" data-jsd-action="install-topic" data-id="preparation">Surface preparation and test fit</button>
          <button class="jsd-chatbot__accent-button" type="button" data-jsd-action="install-topic" data-id="mounting">Alignment and mounting</button>
          <button class="jsd-chatbot__accent-button" type="button" data-jsd-action="install-topic" data-id="care">Post-installation care</button>
        </div>`;
      }
      return '';
    }

    productCard(product) {
      const selected = this.state.selectedProducts.includes(product.id);
      const url = productUrl(product);
      return `
        <article class="jsd-chatbot__product-card${selected ? ' is-selected' : ''}"${url ? ` data-jsd-product-url="${escapeHtml(url)}"` : ''}>
          ${url ? `<a class="jsd-chatbot__product-link" href="${escapeHtml(url)}" aria-label="View ${escapeHtml(product.title)}"></a>` : ''}
          <img class="jsd-chatbot__product-image" src="${this.asset(product.image)}" alt="">
          <h4 class="jsd-chatbot__product-title">${escapeHtml(product.title)}</h4>
          ${this.variationBanner(product)}
          <div class="jsd-chatbot__prices"><s>${escapeHtml(product.comparePrice)}</s><span>${escapeHtml(product.price)}</span></div>
          <button class="jsd-chatbot__product-action jsd-chatbot__secondary-button" type="button" data-jsd-action="select-product" data-id="${product.id}" aria-pressed="${selected}">
            ${selected ? `<img src="${this.asset('jsd-chatbot-check.svg')}" alt="">` : 'Ask AI'}
          </button>
        </article>`;
    }

    productListKey(productList, index) {
      const handles = productList
        .map((product) => product.handle || product.title || '')
        .filter(Boolean)
        .slice(0, 7)
        .join('|');
      return `message-${index}:${handles}`;
    }

    liveProductList(productList, index = 0) {
      const productsToRender = productList.slice(0, 7);
      if (productsToRender.length >= 2 && productsToRender.some((product) => product.cardType === 'comparison')) {
        return this.comparisonModule(productsToRender.filter((product) => product.cardType === 'comparison'));
      }
      const primaryProducts = productsToRender.slice(0, 2);
      const additionalProducts = productsToRender.slice(2, 7);
      const moreCount = additionalProducts.length;
      const listKey = this.productListKey(productsToRender, index);
      const isOpen = (this.state?.openProductLists || []).includes(listKey);
      const additionalMatches = moreCount ? `
        <details class="jsd-chatbot__more-products" data-product-list-key="${escapeHtml(listKey)}"${isOpen ? ' open' : ''}>
          <summary data-jsd-tooltip="${isOpen ? 'Hide additional matches' : 'Show additional matches'}">
            <img src="${this.asset('jsd-chatbot-next.svg')}" alt="">
            <span>${moreCount} more</span>
          </summary>
          <div class="jsd-chatbot__product-list jsd-chatbot__product-list--additional">
            ${additionalProducts.map((product) => this.liveProductCard({ ...product, cardType: 'compact' })).join('')}
          </div>
        </details>` : '';
      return `<div class="jsd-chatbot__product-list jsd-chatbot__product-list--live">
        ${primaryProducts.map((product) => this.liveProductCard(product)).join('')}
        ${additionalMatches}
      </div>`;
    }

    detailValue(value) {
      return String(value || 'Unknown')
        .split(/\n+/)
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => `<span>${escapeHtml(line)}</span>`)
        .join('');
    }

    comparisonValue(product, key) {
      if (key === 'fitment') {
        return [product.fitmentConfidence, product.compatibility].filter(Boolean).join('\n') || 'Unknown';
      }
      return product[key] || 'Unknown';
    }

    variationBanner(product) {
      const finish = String(product.finish || product.color || '').trim();
      if (!finish || /^unknown$/i.test(finish)) return '';
      const options = finish
        .split(/\s*,\s*|\n+/)
        .map((option) => option.trim())
        .filter(Boolean)
        .slice(0, 3);
      if (options.length <= 1) return '';
      return `<div class="jsd-chatbot__variation-banner">${options.map((option) => `<span>${escapeHtml(option)}</span>`).join('')}</div>`;
    }

    moneyAmount(value) {
      const amount = Number(String(value || '').replace(/[^0-9.]/g, ''));
      return Number.isFinite(amount) ? amount : 0;
    }

    priceMarkup(product, className) {
      const price = this.moneyAmount(product.price);
      const compareAtPrice = this.moneyAmount(product.compareAtPrice);
      const hasPrice = Boolean(product.price) && price > 0;
      const hasDiscount = hasPrice && compareAtPrice > price;
      if (!hasPrice && !hasDiscount) return '';
      return `<div class="${className}">${hasDiscount ? `<s>${escapeHtml(product.compareAtPrice)}</s>` : ''}${hasPrice ? `<span>${escapeHtml(product.price)}</span>` : ''}</div>`;
    }

    productBadge(product) {
      const soldOut = product.soldOut === true || product.availableForSale === false || product.availability === 'Sold out';
      if (soldOut) return '<span class="jsd-chatbot__product-badge is-sold-out">Sold Out</span>';
      const price = this.moneyAmount(product.price);
      const compareAtPrice = this.moneyAmount(product.compareAtPrice);
      const discount = compareAtPrice > price && price > 0
        ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
        : Number(product.discountPercent || 0);
      if (discount > 0) {
        return `<span class="jsd-chatbot__product-badge is-sale">${escapeHtml(discount)}% Off</span>`;
      }
      return '';
    }

    comparisonSummary(productList) {
      if (productList.length < 2) return '';
      return '<div class="jsd-chatbot__comparison-summary"><strong>Quick take</strong><p>Choose the item that matches your intended upgrade and confirmed vehicle fitment. Compare the listed purpose, price, materials, finish, and installation requirements.</p></div>';
    }

    comparisonModule(productList) {
      const productsToCompare = productList.slice(0, 7);
      if (productsToCompare.length < 2) return '';
      const rows = [
        { key: 'fitment', label: 'Fitment' },
        { key: 'finish', label: 'Available Finish' },
        { key: 'material', label: 'Material' },
        { key: 'install', label: 'Install' },
      ];
      return `<div class="jsd-chatbot__comparison" style="--jsd-comparison-count:${productsToCompare.length}; --jsd-comparison-width:${productsToCompare.length * 166 - 10}px">
        <div class="jsd-chatbot__comparison-scroller" tabindex="0" aria-label="Product comparison">
          <div class="jsd-chatbot__comparison-grid">
            ${productsToCompare.map((product) => {
    const image = safeLink(product.image) || this.asset('jsd-chatbot-product.png');
    const url = productUrl(product);
    const selected = Boolean(product.handle && (this.state?.referenceProducts || [])
      .some((reference) => reference.handle === product.handle));
    return `<article class="jsd-chatbot__comparison-product${selected ? ' is-selected' : ''}"${url ? ` data-jsd-product-url="${escapeHtml(url)}"` : ''}>
                ${url ? `<a class="jsd-chatbot__comparison-link" href="${escapeHtml(url)}" aria-label="View ${escapeHtml(product.title || 'product')}"></a>` : ''}
                <img src="${escapeHtml(image)}" alt="${escapeHtml(product.imageAlt || product.title || '')}">
                ${this.productBadge(product)}
                <h4>${escapeHtml(product.title || 'Matched product')}</h4>
                ${this.priceMarkup(product, 'jsd-chatbot__comparison-prices')}
                <button class="jsd-chatbot__comparison-action jsd-chatbot__secondary-button" type="button" data-jsd-action="reference-live-product" data-product-handle="${escapeHtml(product.handle || '')}" data-product-title="${escapeHtml(product.title || 'Selected item')}" data-product-image="${escapeHtml(image)}" data-product-image-alt="${escapeHtml(product.imageAlt || product.title || '')}" aria-pressed="${selected}">
                  ${selected ? `<img src="${this.asset('jsd-chatbot-check.svg')}" alt="">` : 'Ask AI'}
                </button>
              </article>`;
  }).join('')}
            ${rows.map((row, rowIndex) => `
              ${productsToCompare.map((product) => `<div class="jsd-chatbot__comparison-cell${rowIndex % 2 ? '' : ' is-alt'}"><span class="jsd-chatbot__comparison-cell-label">${escapeHtml(row.label)}</span><span class="jsd-chatbot__comparison-cell-value">${this.detailValue(this.comparisonValue(product, row.key))}</span></div>`).join('')}
            `).join('')}
          </div>
        </div>
        ${this.comparisonSummary(productsToCompare)}
      </div>`;
    }

    liveProductCard(product) {
      const image = safeLink(product.image) || this.asset('jsd-chatbot-product.png');
      const url = productUrl(product);
      const selected = Boolean(product.handle && (this.state?.referenceProducts || [])
        .some((reference) => reference.handle === product.handle));
      const variationBanner = this.variationBanner(product);
      return `
        <article class="jsd-chatbot__product-card${selected ? ' is-selected' : ''}${variationBanner ? ' has-variations' : ''} is-live"${url ? ` data-jsd-product-url="${escapeHtml(url)}"` : ''}>
          ${url ? `<a class="jsd-chatbot__product-link" href="${escapeHtml(url)}" aria-label="View ${escapeHtml(product.title || 'product')}"></a>` : ''}
          <img class="jsd-chatbot__product-image" src="${escapeHtml(image)}" alt="${escapeHtml(product.imageAlt || product.title || '')}">
          ${this.productBadge(product)}
          <h4 class="jsd-chatbot__product-title">${escapeHtml(product.title || 'Matched product')}</h4>
          ${variationBanner}
          ${this.priceMarkup(product, 'jsd-chatbot__prices')}
          <button class="jsd-chatbot__product-action jsd-chatbot__secondary-button" type="button" data-jsd-action="reference-live-product" data-product-handle="${escapeHtml(product.handle || '')}" data-product-title="${escapeHtml(product.title || 'Selected item')}" data-product-image="${escapeHtml(image)}" data-product-image-alt="${escapeHtml(product.imageAlt || product.title || '')}" aria-pressed="${selected}">
            ${selected ? `<img src="${this.asset('jsd-chatbot-check.svg')}" alt="">` : 'Ask AI'}
          </button>
        </article>`;
    }

    renderReferences() {
      const selected = products.filter((product) => this.state.selectedProducts.includes(product.id));
      const liveProductReferences = this.state.referenceProducts || [];
      const imageAttachments = (this.state.imageAttachments || []).map(normalizeImageAttachment).filter(Boolean);
      this.referenceBox.hidden = !selected.length && !liveProductReferences.length && !imageAttachments.length && !this.state.referenceText;
      const productReferences = selected.map((product) => `
        <button class="jsd-chatbot__reference jsd-chatbot__reference--item" type="button" data-product-id="${product.id}" aria-label="Remove ${escapeHtml(product.title)} reference">
          <img class="jsd-chatbot__reference-image" src="${this.asset(product.image)}" alt="">
          <span class="jsd-chatbot__reference-close" aria-hidden="true"><img src="${this.asset('jsd-chatbot-close.svg')}" alt=""></span>
        </button>`).join('');
      const liveProductReference = liveProductReferences.map((product) => `
        <button class="jsd-chatbot__reference jsd-chatbot__reference--item" type="button" data-reference-product data-product-handle="${escapeHtml(product.handle)}" aria-label="Remove ${escapeHtml(product.title || 'product')} reference">
          <img class="jsd-chatbot__reference-image" src="${escapeHtml(product.image || this.asset('jsd-chatbot-product.png'))}" alt="${escapeHtml(product.imageAlt || '')}">
          <span class="jsd-chatbot__reference-close" aria-hidden="true"><img src="${this.asset('jsd-chatbot-close.svg')}" alt=""></span>
        </button>`).join('');
      const imageReferences = imageAttachments.map((attachment, index) => `
        <button class="jsd-chatbot__reference jsd-chatbot__reference--image" type="button" data-image-attachment="${index}" aria-label="Remove ${escapeHtml(attachment.name)}">
          <img class="jsd-chatbot__reference-image" src="${escapeHtml(attachment.dataUrl)}" alt="${escapeHtml(attachment.imageAlt)}">
          <span class="jsd-chatbot__reference-close" aria-hidden="true"><img src="${this.asset('jsd-chatbot-close.svg')}" alt=""></span>
        </button>`).join('');
      const textReference = this.state.referenceText ? `
        <button class="jsd-chatbot__reference jsd-chatbot__reference--text" type="button" data-reference-text aria-label="Remove reply reference">
          <span>${escapeHtml(this.state.referenceText)}</span>
          <span class="jsd-chatbot__reference-close" aria-hidden="true"><img src="${this.asset('jsd-chatbot-close.svg')}" alt=""></span>
        </button>` : '';
      this.referenceBox.innerHTML = `${productReferences}${liveProductReference}${imageReferences}${textReference}`;
    }
  }

  if (!customElements.get('jsd-space-chatbot')) {
    customElements.define('jsd-space-chatbot', JsdSpaceChatbot);
  }
})();
